module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat#5-1eb720f481fe49e4b7ae231e644a389e.svg";